import { FC } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Button, ButtonProps, Grid } from '@chakra-ui/react';

import { BentoLayoutSize } from 'common/bento/lib/layout';
import useLayoutSizeQuery from 'common/bento/lib/layout/useLayoutSizeQuery';

import * as Subcomponents from './subcomponents';

/**
 * @deprecated use _core/SunshineCard instead
 *
 * An actionable row to be used inside an OBCard.
 *
 * @example <caption>
 *  <OBCardRow>
 *    <Illustration /> or <Status />
 *    <Body>My Text</Body>
 *    <Action />
 *  <OBCardRow>
 * </caption>
 *
 *  |----------------------------|
 *  | ( )  My text            >  |
 *  |----------------------------|
 *
 */
const OBCardRow: typeof Subcomponents & FC<ButtonProps> = ({
  children,
  isDisabled,
  ...props
}) => {
  const isLarge = useLayoutSizeQuery(BentoLayoutSize.md);

  return (
    <Button
      _disabled={{
        cursor: 'not-allowed',
        // We set the opacity in the child, to not affect borders
        opacity: 1,
      }}
      borderRadius="radius-0"
      color="grey.-2"
      fontWeight="weight-400"
      height="auto"
      isDisabled={isDisabled}
      margin={0}
      minHeight="space-64"
      paddingY="space-4"
      position="relative"
      role="group"
      width="100%"
      {...props}
    >
      <Grid
        _hover={{
          backgroundColor: 'grey.5',
        }}
        alignItems="center"
        gridGap="space-16"
        gridTemplateColumns="auto 1fr auto"
        opacity={isDisabled ? 0.5 : undefined}
        paddingX={isLarge ? 'space-16' : 'space-8'}
        paddingY="space-8"
        transitionDuration="duration-300"
        transitionProperty="background-color"
        transitionTimingFunction="ease-out"
        width="100%"
      >
        {children}
      </Grid>
    </Button>
  );
};

OBCardRow.Illustration = Subcomponents.Illustration;
OBCardRow.Body = Subcomponents.Body;
OBCardRow.BodyDescription = Subcomponents.BodyDescription;
OBCardRow.Action = Subcomponents.Action;

export default OBCardRow;
